import { Experiment, useExperiments } from '@redbubble/next/experiments';
import { usePageProps } from '@redbubble/next-provider';
import dynamic from 'next/dynamic';
import React from 'react';
import type { ProductPageProps } from '../../types';

const PrimaryContentSection = dynamic(
  () =>
    import(
      /* webpackChunkName: "LegacyPrimaryContentSection" */
      './PrimaryContentSection'
    ).then((m) => m.PrimaryContentSection),
  { ssr: true }
);

const PTRPrimaryContentSection = dynamic(
  () =>
    import(
      /* webpackChunkName: "PTRPrimaryContentSection" */
      '../PTRPrimaryContentSection/PTRPrimaryContentSection'
    ).then((m) => m.PTRPrimaryContentSection),
  { ssr: true }
);

export interface PrimaryContentExperimentSwitcherProps {
  setAtcDrawerOpen: (open: boolean) => void;
  setConfettiActive: (active: boolean) => void;
}

// NOTE(jj) 20260312: This component should only exist while the 'ptr-product-configurator' experiment is running.
// Please remove this file when 'ptr-product-configurator' is no longer being used.
export const PrimaryContentExperimentSwitcher: React.FC<
  PrimaryContentExperimentSwitcherProps
> = ({ setAtcDrawerOpen, setConfettiActive }) => {
  const { productTypes, productFamilies } = usePageProps<ProductPageProps>();
  const experiments = useExperiments();
  const isPtr = experiments.isVariant(Experiment.PTRConfigurator);

  if (isPtr && productTypes) {
    return (
      <PTRPrimaryContentSection
        setAtcDrawerOpen={setAtcDrawerOpen}
        setConfettiActive={setConfettiActive}
        productTypes={productTypes}
        productFamilies={productFamilies}
      />
    );
  }

  return (
    <PrimaryContentSection
      setAtcDrawerOpen={setAtcDrawerOpen}
      setConfettiActive={setConfettiActive}
    />
  );
};
